import firebase from 'firebase'

const firebaseConfig = {
    apiKey: "AIzaSyCDIb_8xu4jSQX9548VH_vaMo3USr-PIxo",
    authDomain: "clone-37465.firebaseapp.com",
    projectId: "clone-37465",
    storageBucket: "clone-37465.appspot.com",
    messagingSenderId: "571698969012",
    appId: "1:571698969012:web:a12c22055f0499ff651ae1"
};

const firebaseApp=firebase.initializeApp(firebaseConfig)

const db=firebaseApp.firestore()
const auth = firebase.auth()

export {db,auth}